import React from 'react';
import { Link } from '@tanstack/react-router';

import { formatDate } from '../../../helpers';

import type { AssetGroup } from '../../../types/asset-group';

interface DashboardAdminAssetGroupProps {
  assetGroup: AssetGroup;
  handleEditAssetGroup: (assetGroup: AssetGroup) => Promise<void>;
  handleDeleteAssetGroup: (assetGroup: AssetGroup) => Promise<void>;
};

const DashboardAdminAssetGroup: React.FC<DashboardAdminAssetGroupProps> = ({ assetGroup, handleEditAssetGroup, handleDeleteAssetGroup }) => {
  const deleteAssetGroup = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    handleDeleteAssetGroup(assetGroup);
  };

  return (
    <tr className="dashboard-admin-asset-group">
      <td>{assetGroup.name}</td>
      <td>{assetGroup.visible_from ? formatDate(assetGroup.visible_from) : '—'}</td>
      <td>{assetGroup.visible_to ? formatDate(assetGroup.visible_to) : '—'}</td>
      <td>{assetGroup.assets_count}</td>
      <td className="actions">
        <div className="wa-cluster wa-gap-2xs">
          <Link
            to="#edit"
            id={`asset-group-${assetGroup.id}-edit`}
            aria-label={`Edit group ${assetGroup.name}`}
            onClick={(e) => {
              e.preventDefault();
              handleEditAssetGroup(assetGroup);
            }}
          >
            <i className="fa-light fa-pen-to-square" />
          </Link>
          <wa-tooltip for={`asset-group-${assetGroup.id}-edit`} placement="top">
            Edit group
          </wa-tooltip>
          <Link to="#delete" id={`asset-group-${assetGroup.id}-delete`} onClick={deleteAssetGroup}>
            <i className="fa-light fa-trash" />
          </Link>
          <wa-tooltip for={`asset-group-${assetGroup.id}-delete`} placement="top">
            Delete group
          </wa-tooltip>
        </div>
      </td>
    </tr>
  );
}

export default DashboardAdminAssetGroup;
